import {Button, IconButton, Popover, TextField, Tooltip} from "@mui/material";
import {Lock, LockOpen} from "@mui/icons-material";
import {useState} from "react";
import {UnitSystem} from "../../../../../api/Projects";
import {MetricParser} from "../../../../../misc/MetricParser";
import {ImperialParser} from "../../../../../misc/ImperialParser";
import {inches, mm} from "../const";
import {ImperialDistance} from "../../../../../misc/ImperialDistance";

export function DimensionEditor(props: {
    value: number;
    sys: UnitSystem;
    locked: boolean;

    onLockChange: (locked: boolean) => void;
    onDone: (value: number) => void;
    onCancel: () => void;
}) {
    const [anchor, setAnchor] = useState<HTMLDivElement | null>(null);
    const [value, setValue] = useState(formatDim(props.value, props.sys));

    const submit = () => {

        const flt = parseDimension(value, props.sys);
        if(isNaN(flt)) return;

        props.onDone(flt);
    };

    return (
        <>
            <div ref={setAnchor}></div>
            {anchor && <Popover anchorEl={anchor} open onClose={() => props.onCancel()}>
                <div style={{display: "flex", alignItems: "stretch"}}>
                    <TextField
                        onChange={e => setValue(e.currentTarget.value)}
                        onFocus={e => e.currentTarget.select()}
                        value={value}
                        onKeyDown={e => {
                            if(e.key === "Enter") {
                                submit();
                            }
                        }}
                        autoFocus
                        style={{minWidth: 30, width: 80}}
                    />
                    <Tooltip title={props.locked ? "Locked" : "Unlocked"}>
                        <IconButton onClick={() => props.onLockChange(!props.locked)} size="small">
                            {props.locked ? <Lock fontSize="small" /> : <LockOpen fontSize="small" />}
                        </IconButton>
                    </Tooltip>
                    <Button onClick={() => submit()} style={{height: "auto"}}>Done</Button>
                </div>
            </Popover>}
        </>
    )
}

export function parseDimension(value: string, sys: UnitSystem) {
    if(sys === "metric") {
        return MetricParser.parse(value).mm * mm;
    } else {
        const result = ImperialParser.parse(value);
        return result.feet  * 12 * inches + result.inches * inches
    }
}

export function formatDim(value: number, sys: UnitSystem) {
    if(isNaN(value)) return "_invalid: " + value;

    if(sys === "metric") {
        return (value / mm).toFixed(2) + " mm";
    } else {
        return (new ImperialDistance(Math.round(value / inches * 64))).toInchesString();
    }
}